import { getImageUrl } from '~/components/Image/helpers'
import {
  HIGHER_GRADES_FIRST_GRADE_LEVEL,
  VIDEO_POSTER_ASPECT_RATIO,
  VIDEO_POSTER_BACKGROUND_KEYS,
  VIDEO_POSTER_WIDTH,
  VideoPosterGradeBand,
} from '~/curriculum/constants/videoPoster.const'

/** Band follows the grade being viewed, since a video can belong to several. Unknown grade -> lower. */
export function getVideoPosterGradeBand(gradeLevel: number): VideoPosterGradeBand {
  return gradeLevel >= HIGHER_GRADES_FIRST_GRADE_LEVEL
    ? VideoPosterGradeBand.HIGHER_GRADES
    : VideoPosterGradeBand.LOWER_GRADES
}

const normaliseTitle = (value: string): string => value.trim().replace(/\s+/g, ' ').toLowerCase()

/** The description the old posters displayed, or `''`. Rejects slugs pasted into the field. */
export function getUsableVideoDescription(description: string | undefined): string {
  const trimmed = description?.trim() ?? ''
  const isSlug = !/\s/.test(trimmed) && trimmed.includes('_')

  return isSlug ? '' : trimmed
}

/** Headline for a video under its own heading — `''` when it would repeat it. Ignores case/whitespace. */
export function getVideoPosterTitle(description: string | undefined, pageTitle: string): string {
  const usable = getUsableVideoDescription(description)

  return usable.length > 0 && normaliseTitle(usable) !== normaliseTitle(pageTitle) ? usable : ''
}

/** srcKey -> URL. The `poster` attribute needs a plain URL, so not `ResponsiveImage`. */
export function getVideoPosterUrl(gradeLevel: number): string {
  const backgroundKey = VIDEO_POSTER_BACKGROUND_KEYS[getVideoPosterGradeBand(gradeLevel)]

  return getImageUrl(
    Math.round(VIDEO_POSTER_WIDTH * VIDEO_POSTER_ASPECT_RATIO),
    VIDEO_POSTER_WIDTH,
    'cover',
    backgroundKey,
    undefined,
  ).urlWithFormat
}
